var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_236289198090873310674462145415083968900",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_74962271033207068766791463455676817793",
    d: "M10.836 1.475c.02.079.03.16.03.242v1.172H17c.552 0 1 .448 1 1V22.11c0 .552-.448 1-1 1h-6.135v1.603c0 .553-.447 1-1 1-.082 0-.165-.01-.246-.03L.845 23.456c-.443-.113-.754-.512-.754-.97V3.903c0-.46.313-.86.759-.97L9.624.745c.536-.133 1.078.193 1.212.729zm-2.004.504l-.114.024-7 1.887c-.397.107-.683.444-.732.844l-.008.122v16.682c0 .41.25.773.62.925l.115.04 7 1.923c.087.024.176.036.265.036.513 0 .936-.386.994-.883l.006-.117V2.968c0-.088-.011-.175-.034-.26-.134-.495-.616-.803-1.112-.73zm2.033 19.687H15.5c.513 0 .936-.385.993-.883l.007-.116V5.333c0-.513-.386-.935-.883-.993l-.117-.007h-4.635v17.333zM9 10.11v1.445H7.5v2.888H9v1.445H7.444c-.797 0-1.444-.647-1.444-1.445v-2.888c0-.798.647-1.445 1.444-1.445H9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(7 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_113948369839651968073676400403962169247",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_74962271033207068766791463455676817793"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#hinava_random_uuid_74962271033207068766791463455676817793"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#hinava_random_uuid_236289198090873310674462145415083968900)",
    mask: "url(#hinava_random_uuid_113948369839651968073676400403962169247)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    transform: "translate(-7 -3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.6bb3910865b96627ca197f9ef593f9b6.svg";
export { ForwardRef as ReactComponent };